import { render } from "./BasicColumnDashboard.vue?vue&type=template&id=4de3723c"
import script from "./BasicColumnDashboard.vue?vue&type=script&lang=js"
export * from "./BasicColumnDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__